<div class="actiuni-card-container action-card-{{actionType}}" [class.selected]="selectedClass()">
    <div class="card-status">
        <div class="card-header">
            <span class="title">{{ title }}</span>
            <span class="description" *ngIf="
                (actionType == 'inchidere' && proiect?.validated_date == null) 
                || (actionType == 'anulare' && proiect?.cancel_date == null)
            ">{{ description }}</span>
        </div>
    </div>
    <div class="card-content" *ngIf="actionType == 'inchidere' && proiect?.validated_date !== null">
        <div class="card-content__header">
            <span class="user"><i class="fa-regular fa-user"></i> {{ proiect?.validated_user_name }}</span>
            <span class="date"><i class="fa-regular fa-calendar-check"></i> {{ proiect?.validated_date }}</span>
        </div>
        <div class="card-content__body">
            <div class="card-content__body__text">
                <i class="fa-regular fa-message"></i>
                <span [innerHTML]="proiect?.validated_obs"></span>
            </div>
        </div>
    </div>
    <div class="card-content" *ngIf="actionType == 'anulare' && proiect?.cancel_date !== null">
        <div class="card-content__header">
            <span class="user"><i class="fa-regular fa-user"></i> {{ proiect?.cancel_user_name }}</span>
            <span class="date"><i class="fa-regular fa-calendar-check"></i> {{ proiect?.cancel_date }}</span>
        </div>
        <div class="card-content__body">
            <div class="card-content__body__text">
                <i class="fa-regular fa-message"></i>
                <span [innerHTML]="proiect?.cancel_obs"></span>
            </div>
        </div>
    </div>
    <div class="card-actions">
        <div class="card-image">
            <mat-icon [ngStyle]="{'color': iconColor}">{{ iconName }}</mat-icon>
        </div>
        <div class="card-button">
            <button *ngIf="
                    (actionType == 'inchidere' && permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.inchidere-proiect')) 
                    || (actionType == 'anulare' && permissionsService.hasPermission('monitoring-module.proiecte.proiecte-view.anulare-proiect'))
                " type="button" mat-raised-button color={{btnColor}} class="action-button" [disabled]="
					(actionType == 'inchidere' && proiect?.validated_date !== null || proiect?.cancel_date !== null) 
					|| (actionType == 'anulare' && proiect?.cancel_date !== null || proiect?.validated_date !== null)
				" (click)="onButtonClick()">{{ actionText }}</button>
        </div>
    </div>
    <!-- <div class="card-footer" *ngIf="
        (actionType == 'inchidere' && proiect?.validated_date !== null && proiect?.cancel_type == null && proiect?.finished_date == null) 
        || (actionType == 'anulare' && proiect?.cancel_date !== null && proiect?.finished_date == null)
    ">
        <div class="card-button">
            <button type="button" mat-raised-button color={{btnColor}} class="action-button w-100"
                (click)="onButtonResetClick()"><mat-icon style="color: 'red'">report_problem</mat-icon> Reset</button>
        </div>
    </div> -->
</div>

<!-- <div class="actiuni-card-container action-card-{{actionType}}" [class.selected]="selectedClass()">
	<div class="card-status">
		<div class="card-header">
			<span class="title">{{ title }}</span>
			<span class="description" *ngIf="
				(actionType == 'validate' && cerere?.validated_date == null) 
				|| (!['validate'].includes(actionType) && actionText !== 'finalizare' && cerere?.cancel_date == null)
				|| (actionType == 'finalizare')
			">{{ description }}</span>
		</div>
	</div>
	<div class="card-content" *ngIf="actionType == 'validate'">
		<div class="card-content__header">
			<span class="user"><i class="fa-regular fa-user"></i> {{ cerere?.validated_user_name }}</span>
			<span class="date"><i class="fa-regular fa-calendar-check"></i> {{ cerere?.validated_date }}</span>
		</div>
	</div>
	<div class="card-content" *ngIf="['invalidate', 'anulare'].includes(actionType) && cerere?.cancel_date !== null">
		<div class="card-content__header">
			<span class="user"><i class="fa-regular fa-user"></i> {{ cerere?.cancel_user_name }}</span>
			<span class="date"><i class="fa-regular fa-calendar-check"></i> {{ cerere?.cancel_date }}</span>
		</div>
		<div class="card-content__body">
			<div class="card-content__body__text">
				<i class="fa-regular fa-message"></i> {{ cerere?.cancel_obs }}
			</div>
		</div>
	</div>
	<div class="card-content" *ngIf="['finalizare'].includes(actionType) && cerere?.finalize_date !== null">
		<div class="card-content__header">
			<span class="user"><i class="fa-regular fa-user"></i> {{ cerere?.registratura?.user_name }}</span>
			<span class="date"><i class="fa-regular fa-calendar-check"></i> {{ cerere?.registratura?.finalize_date }}</span>
			<span class="date"><i class="fa-regular fa-comments"></i> {{ cerere?.registratura?.finalize_name }}</span>
		</div>
		<div class="card-content__body">
			<div class="card-content__body__text">
				<i class="fa-regular fa-message"></i> {{ cerere?.registratura?.finalize_obs  }}
			</div>
		</div>
	</div>
	<div class="card-actions">
		<div class="card-image">
			<mat-icon [ngStyle]="{'color': iconColor}">{{ iconName }}</mat-icon>
		</div>
		<div class="card-button">
			<button *ngIf="
                    (actionType == 'validate' && permissionsService.hasPermission('urbanism-module.solicitari.view.validare-cerere')) 
                    || (actionType == 'invalidate' && permissionsService.hasPermission('urbanism-module.solicitari.view.invalidare-cerere'))
                    || (actionType == 'anulare' && permissionsService.hasPermission('urbanism-module.solicitari.view.clasare-cerere'))
                    || (actionType == 'finalizare' && permissionsService.hasPermission('urbanism-module.solicitari.view.inchidere-lucrare'))
                " type="button" mat-raised-button color={{btnColor}} class="action-button" [disabled]="
					(actionType == 'validate' && cerere?.validated_date !== null) 
					|| (actionType == 'invalidate' && cerere?.cancel_date !== null)
					|| (actionType == 'anulare' && cerere?.cancel_date !== null)
					|| (actionType == 'finalizare' && cerere?.registratura?.finalize_date !== null) 
				" (click)="onButtonClick()">{{ actionText }}</button>
		</div>
	</div>
	<div class="card-footer" *ngIf="
		(actionType == 'validate' && permissionsService.hasPermission('urbanism-module.cerere.resetare-validare') && cerere?.validated_date !== null && cerere?.cancel_type == null && cerere?.registratura?.finalize_date == null) 
		|| (actionType == 'invalidate' && permissionsService.hasPermission('urbanism-module.cerere.resetare-invalidare') && cerere?.cancel_date !== null && cerere?.registratura?.finalize_date == null)
		|| (actionType == 'anulare' && permissionsService.hasPermission('urbanism-module.cerere.resetare-clasare') && cerere?.cancel_date !== null && cerere?.registratura?.finalize_date == null)
		|| (actionType == 'finalizare' && permissionsService.hasPermission('urbanism-module.cerere.resetare-finalizare') && cerere?.registratura?.finalize_date !== null)
	">
		<div class="card-button">
			<button  type="button" mat-raised-button color={{btnColor}} class="action-button w-100"  
			(click)="onButtonResetClick()"><mat-icon style="color: 'red'">report_problem</mat-icon> Reset</button>
		</div>
	</div>
</div> -->